import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TsButtonModule } from 'tsui';

@Component({
  selector: 'ts-image-upload',
  templateUrl: './ts-image-upload.component.html',
  styleUrls: ['./ts-image-upload.component.scss'],
  standalone: true,
  imports: [CommonModule, TsButtonModule, NgOptimizedImage],
})
export class TsImageUploadComponent {
  @Input() imageUrl: string;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  @Output() imageChanged = new EventEmitter<File>();
  @Output() imageRemoved = new EventEmitter<void>();

  get bubbleSize(): string {
    switch (this.size) {
      case 'lg':
        return 'min-w-32 min-h-32 w-32 h-32';
      case 'sm':
        return 'min-w-16 min-h-16 w-16 h-16';
      default:
        return 'min-w-24 min-h-24 w-24 h-24';
    }
  }
}
